import Dexie from "dexie";
import db from "../Db";

var UpdateLieu = Dexie.async(function* (LIEU) {
  yield db.open();
  yield db.LIEU.put(LIEU);
});

export default UpdateLieu;
